<template lang="pug">
</template>

<script>
export default {
  name: 'AuthorizeOutside',
  data: () => ({
    isLoading: false,
  }),
  created() {
    this.loginByTelegram();
  },
  methods: {
    async loginByTelegram() {
      const payload = {
        auth_result: this.$route.hash.split('=')[1],
        role: 5,
      };
      const { data } = await this.$api.auth.telegramAuth(payload);
      if (data) {
        const { access_token: accessToken, refresh_token: refreshToken } = data.data;
        await this.$store.dispatch('auth/INIT_USER', { accessToken, refreshToken });
        this.$router.push({ name: 'UserProfile' });
      }
    },
  },
};
</script>

<style lang="scss" scoped>

</style>
